import React from 'react';
import initializeComponent from '../Shared/react-initialize';
import RecommendedProductsWrapper from '../related-products-wrapper';
import withHideOnIBB from '../with_hide_on_ibb';
import { useSelectedOptionid } from '../shared-state.js';

function RecommendedProductGroup(props) {
   const [optionid] = useSelectedOptionid();
   const activeProps = props.relatedByOptionid[optionid];

   if (!activeProps) {
      return null;
   }

   return (
      <React.Fragment>
         <div className="section-divider">
            <p className="product-details">{_js('Frequently Bought Together')}</p>
         </div>
         <RecommendedProductsWrapper activeProps={activeProps} />
      </React.Fragment>
   );
}

initializeComponent('RelatedProducts', withHideOnIBB(RecommendedProductGroup));
